import DataQuery from 'data/DataQuery';
import { Customer_Supplier } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React from 'react'
import { useSelector } from 'react-redux';
import SupplierInfoCard from 'features/customer/components/SupplierInfoCard';
import CustomerSupplierDTO from 'features/customer/dtos/CustomerSupplierDTO';
import Card from 'features/shared/components/card/Card';
import { useTranslation } from 'react-i18next';

type Props = {}

const SuppliersSection = (props: Props) => {
  // translations
  const tLabels = useTranslation("customer\\customer").t;

  // store
  const customer = useSelector<IAppState, CustomerState>( (store) => store.customer).customer;

  // fetch data
  const query: DataQuery = {
    url: Customer_Supplier,
    routeParams: getRouteParams("customerId", customer.customerId!)
  };
  const { data: suppliers, loadStatus } = useQuery<CustomerSupplierDTO[]>(query, []);

  // sub-renders
  const renderSuppliers = () => { 
    return suppliers.map((supplier) =>
      <div className="col-sm-auto pb-3 pr-sm-5" key={supplier.supplierId}>
        <SupplierInfoCard supplier={supplier} />
      </div>
    );
  }

  // render
  return (
    <NoContentWrapper
      data={suppliers}
      loadStatus={loadStatus}
      noContentRender={() => <></>}
    >
      <h4 className="text-muted">{tLabels("supplierSection.supplier")}</h4>
      <Card className='px-4 pt-4 pb-2'>
        <div className="row no-gutters">
          {renderSuppliers()}
        </div>
      </Card>
    </NoContentWrapper>
  )
}

export default SuppliersSection